import { render, staticRenderFns } from "./SharingIndicators.vue?vue&type=template&id=1fd5867f&"
import script from "./SharingIndicators.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SharingIndicators.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports